import httpAdminClient from '@/plugins/httpAdminClient';

export default {
  show(projectId, stageId) {
    return httpAdminClient.get(`research/admin/projects/${projectId}/stages/${stageId}`);
  },
  patch(projectId, stageId, data) {
    return httpAdminClient.patch(`research/admin/projects/${projectId}/stages/${stageId}`, { research_stage: { ...data } });
  },
  update(projectId, stageId, data) {
    return httpAdminClient.patch(`research/admin/projects/${projectId}/stages/${stageId}`, { research_stage: { ...data } });
  },
  transmit(projectId, stageId, event) {
    return httpAdminClient.post(`research/admin/projects/${projectId}/stages/${stageId}/transmit?event=${event}`);
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/adminApis/research/api-stage.js